import { Form, Input } from 'antd';
import PropTypes from 'prop-types';
import './Hechos.scss';

const Hechos = ({ form }) => {
  return (
    <div>
      <Form form={form} layout="vertical">
        <div>
          <Form.Item name="usoVoz" label="Uso de la voz:">
            <Input.TextArea rows={8} showCount maxLength={5000} placeholder="Escribe" />
          </Form.Item>
          <Form.Item name="hechos" label="Otros Hechos:">
            <Input.TextArea rows={8} showCount maxLength={5000} placeholder="Escribe" />
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default Hechos;

Hechos.propTypes = {
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func,
    getFieldsValue: PropTypes.func
  }).isRequired
};
